module.exports = __webpack_public_path__ + "images/website2-cca465bb49b7bb64d6060276663c1004.jpg";